package dev.bitspittle.droidconSf24.pages.sections.html

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun CMPvsComposeHtmlPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/html/CMPvsComposeHtml.md", mapOf("follows" to listOf("Html2Compose"), "layout" to listOf("top"), "styles" to listOf("accented-subheaders"), "behaviors" to listOf("auto-fragment LI", "auto-progress-fragments 100")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("cmp-for-web-vs-compose-html") }) {
                org.jetbrains.compose.web.dom.Text("CMP for Web ")
                com.varabyte.kobweb.compose.dom.GenericTag("span", "style=\"color:red\"") {
                    org.jetbrains.compose.web.dom.Text("vs")
                }
                org.jetbrains.compose.web.dom.Text(" Compose HTML")
            }
            org.jetbrains.compose.web.dom.H3(attrs = { id("why-compose-html") }) {
                org.jetbrains.compose.web.dom.Text("Why Compose HTML?")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Avoid large canvas buffer")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Smaller site download size")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Browser devtools")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Browser accessibility")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Special CSS styles (e.g. visited links)")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Compatible with JS frameworks")
                }
            }
        }
    }
}
